import React from 'react';
import c from 'classnames';
import s from './Stack.scss';

interface Props {
  children: React.ReactNode;
  gap?: number;
  className?: string;
}

const Stack: React.FC<Props> = ({ children, gap, className }) => {
  return (
    <div className={c(s['root'], className)} style={{ gap }}>
      {children}
    </div>
  );
};

Stack.displayName = 'Stack';

export default Stack;
